import { useEffect, useRef } from 'react'

import { config } from '@percent/cause-dashboard/config'

const WIDGET_ID = 'hs-script-loader'

declare global {
  interface Window {
    hbspt?: any
  }
}

export function useHubSpotWidget() {
  const scriptRef = useRef<HTMLScriptElement>()

  useEffect(() => {
    const widgetKey = config.keys.hubspotWidgetKey

    if (!widgetKey || widgetKey === 'undefined') {
      console.warn('HubSpot widget key is not configured, skipping widget initialization')
      return
    }

    const hubspotScript = document.getElementById(WIDGET_ID)

    if (hubspotScript) {
      scriptRef.current = hubspotScript as HTMLScriptElement
    } else {
      const widgetSrc = `//js-eu1.hs-scripts.com/${widgetKey}.js`

      const newHubspotScript = document.createElement('script')
      newHubspotScript.setAttribute('id', WIDGET_ID)
      newHubspotScript.setAttribute('src', widgetSrc)
      newHubspotScript.setAttribute('type', 'text/javascript')
      newHubspotScript.setAttribute('async', 'true')
      newHubspotScript.setAttribute('defer', 'true')

      newHubspotScript.onload = () => {
        if (window.hbspt) {
          window.hbspt.create('conversations', {
            portalId: widgetKey,
            target: 'body'
          })
        }
      }

      document.body.appendChild(newHubspotScript)
      scriptRef.current = newHubspotScript
    }

    return () => {
      window.hbspt?.destroy?.()
      scriptRef.current?.remove()
    }
  }, [])

  return null
}
